export const WEBVIEW_REGEX = new RegExp('iPhone|iPad|Android')
